'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var mainNewsOverviewComponent = exports.mainNewsOverviewComponent = {
    template: require('./main-overview.html'),
    bindings: {
        recentnews: '<',
        popularnews: '<',
        tags: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "common", "newsService", "newsOverviewService", "Enums", "gettextCatalog", "$state", "Analytics", function mainNewsOverviewController($scope, common, newsService, newsOverviewService, Enums, gettextCatalog, $state, Analytics) {
        'ngInject';

        var vm = this;
        vm.newsOverviewModel = null;
        vm.$onInit = init;
        vm.itemsPerPageChanged = itemsPerPageChanged;
        vm.badgeClicked = badgeClicked;

        function init() {
            common.navigationMenu.setNewsActive();
            common.setTitle(gettextCatalog.getString('News'));
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/news', gettextCatalog.getString('News'));

            handleGetNews(12); //default page size is 12 todo put in const
        }

        function itemsPerPageChanged(itemsPerPage) {
            handleGetNews(itemsPerPage);
        }

        function handleGetNews(itemsPerPage) {
            newsOverviewService.handleGetNews($scope, Enums.newsContext.main.id, {}, itemsPerPage).then(function (model) {
                vm.newsOverviewModel = model;
            });
        }

        function badgeClicked(categoryId) {
            $state.go('.', {
                page: 1,
                categoryId: categoryId
            });
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/news/main-overview.js
// module id = 953
// module chunks = 0